export const MAX_CHILD_AGE = 16;
export const MAX_INFANT_AGE = 1;

/**
 * @note This values are taken only for kaztour, since it's basically the only operator that we will use.
 * In the future, we will probably have to implement some kind of logic that will get this values dynamically
 */
export const MAX_PASSENGER_COUNT = {
  ADULTS: 8,
  CHILDREN: 4,
};
